import JobList from "./JobList";
import { FaBriefcase, FaHeart, FaHandshake, FaRocket } from 'react-icons/fa';

function VacancySection() {
    return (
        <>
            <section id="vagas" className="py-20 bg-gradient-to-b from-white to-red-50 scroll-mt-16">
                <div className="container mx-auto px-4">
                    {/* Section Header */}
                    <div className="text-center mb-16">
                        <span className="inline-block bg-red-100 text-red-600 px-4 py-1 rounded-full text-sm font-semibold mb-4">
                            OPORTUNIDADES DE CARREIRA
                        </span>
                        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Trabalhe Conosco</h2>
                        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                            Estamos em busca de pessoas talentosas, comprometidas e que queiram crescer junto com a gente. 
                            Se você gosta de desafios, valoriza um ambiente colaborativo e busca constantemente inovação, 
                            o seu lugar é aqui!
                        </p>
                        <div className="w-24 h-1 bg-gradient-to-r from-red-600 to-yellow-400 mx-auto mt-6 rounded"></div>
                    </div>

                    {/* Benefits Section */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-16">
                        <div className="bg-white p-6 rounded-lg shadow-md text-center border-t-4 border-red-600">
                            <FaBriefcase size={40} className="text-red-600 mx-auto mb-3" />
                            <h3 className="font-bold text-gray-900 mb-2">Carreira</h3>
                            <p className="text-gray-600 text-sm">Oportunidades de crescimento profissional</p>
                        </div>
                        <div className="bg-white p-6 rounded-lg shadow-md text-center border-t-4 border-red-600">
                            <FaHeart size={40} className="text-red-600 mx-auto mb-3" />
                            <h3 className="font-bold text-gray-900 mb-2">Benefícios</h3>
                            <p className="text-gray-600 text-sm">Pacote completo de benefícios</p>
                        </div>
                        <div className="bg-white p-6 rounded-lg shadow-md text-center border-t-4 border-red-600">
                            <FaHandshake size={40} className="text-red-600 mx-auto mb-3" />
                            <h3 className="font-bold text-gray-900 mb-2">Equipe</h3>
                            <p className="text-gray-600 text-sm">Ambiente colaborativo e acolhedor</p>
                        </div>
                        <div className="bg-white p-6 rounded-lg shadow-md text-center border-t-4 border-red-600">
                            <FaRocket size={40} className="text-red-600 mx-auto mb-3" />
                            <h3 className="font-bold text-gray-900 mb-2">Inovação</h3>
                            <p className="text-gray-600 text-sm">Sempre em busca de novas soluções</p>
                        </div>
                    </div>

                    {/* Job List */}
                    <div className="mb-12">
                        <div className="text-center mb-8">
                            <h3 className="text-2xl font-bold text-gray-900 mb-2">Vagas em Aberto</h3>
                            <p className="text-gray-600">Confira as oportunidades disponíveis agora</p>
                        </div>
                        <div className="">
                            <JobList />
                        </div>
                    </div>

                    {/* CTA Button */}
                    <div className="text-center">
                        <a 
                            type="button" 
                            href="https://distribuidorayork.vagas.solides.com.br" 
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center space-x-2 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white px-10 py-2 rounded-lg font-bold shadow-lg hover:shadow-xl transition duration-300 transform hover:scale-105"
                        >
                            <FaBriefcase size={20} />
                            <span>Ver Todas as Vagas</span>
                        </a>
                        <p className="text-gray-600 mt-4 text-sm">
                            Não encontrou a vaga perfeita? Envie seu currículo mesmo assim!
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default VacancySection;